import styled from '@emotion/styled';
export const Wrapper = styled.div `
  padding-bottom: 5px;
  padding-top: 5px;
  text-align: ${({ align }) => align};
  background-color:${({ color }) => color};

  .list-wrap {
    display: flex;
    flex-wrap: wrap;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;
export const ColumnWrapper = styled.div `
  display: inline-flex;
  box-sizing: border-box;
  width: ${({ width }) => width}%;
  vertical-align: top;
  padding: 5px 7px;
  position: relative;
`;
export const SubTitle = styled.h3 `
  letter-spacing: 0.3px;
  color: rgba(3, 2, 26, 0.8);
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  margin-top: 5px;
  margin-left: 10px;
`;
